// utils/modal-prompt.js
import { useModalStore } from "@/stores/use-modal-store";
import { ConfirmModal } from "@/components/modal/confirm-modal";
import { AlertDialogWrapper } from "@/components/modal/alert-dialog-wrapper";
import { useGlobalLoadingStore } from "@/stores/use-global-loading-store";

/**
 * confirm() - 확인/취소 모달
 */
export async function confirm(message, options) {
  const { openModal } = useModalStore.getState();
  return openModal(
    ConfirmModal,
    {
      title: options?.title || "확인",
      description: message,
      confirmText: options?.confirmText || "확인",
      cancelText: options?.cancelText || "취소",
    },
    { variant: "default" }
  ).then((result) => {
    return result.action === "confirm";
  });
}

/**
 * alert() - 알림 모달
 */
export async function alert(message, options) {
  const { openModal } = useModalStore.getState();
  openModal(
    AlertDialogWrapper,
    {
      title: options?.title || "알림",
      description: message,
      confirmText: options?.confirmText || "확인",
    },
    { variant: "alert" }
  );
}

/**
 * showLoading() - 글로벌 로딩 표시
 */
export async function showLoading(isOpen = true, message, subMessage) {
  const { startLoading, stopLoading } = useGlobalLoadingStore.getState();
  if (isOpen) {
    startLoading(message, subMessage);
  } else {
    stopLoading();
  }
}
